import { PaymentStatus } from '../EventBooking';

export interface BookingPaymentStatusResponse {
  status: PaymentStatus;
}
